import { createFileRoute } from '@tanstack/react-router';
import { AppReviewAnalyzerPage } from '../../../pages/tools/market/AppReviewAnalyzerPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/app-review-analyzer')({
  head: () => toolHead('app-review-analyzer'),
  component: AppReviewAnalyzerPage,
});
